<template>
    <div class="rv-update-mobile">
        <div>
            <div class="img-mobile pt-3 pb-2 mx-2 d-flex flex-nowrap">
                <div class="upload-img text-center px-2">
                    <div class="btn-upload" role="button">
                        <i class="icon ion-md-cloud-upload"></i>
                        <p class="mb-0 fs-14px">
                            Tải ảnh lên
                        </p>
                    </div>
                </div>
                <div class="img px-2 position-relative" v-for="(item, index) in 19" :key="index">
                    <img class="w-100 h-100" src="https://picsum.photos/200"/>
                    <div class="delete-img position-absolute">
                        <i class="icon ion-ios-close"></i>
                    </div>
                    <div class="checked-img position-absolute text-center">
                        <div class="btn-check text-center">
                            <i class="icon ion-md-checkmark mr-1 fs-12px"></i>
                            <span class="fs-12px">Ảnh chính</span>
                        </div>
                    </div>
                </div>
            </div>
            <p class="note-img text-secondary fs-12px ml-3">* Click vào ảnh để thay đổi ảnh chính</p>
        </div>
        <div class="info-post-mobile">

        </div>
    </div>
</template>

<script>
    export default {

    }
</script>

<style lang="scss">
    .rv-update-mobile {
        overflow: hidden !important;
        .img-mobile {
            overflow-x: auto;
            .img {
                height: 100px;
                flex: 0 0 120px;
                img {
                    object-fit: cover;
                    box-shadow: 0 4px 6px rgba(50,50,93,.11),0 1px 3px rgba(0,0,0,.08);
                    border-radius: 4px;
                }
            }
            .upload-img {
                height: 100px;
                flex: 0 0 120px;
                .btn-upload {
                    border-radius: 4px;
                    border: 2px dashed rgba(0,0,0,0.2);
                    height: 100%;
                    padding: 10px 0px;
                    i {
                        font-size: 30px;
                        color: #666;
                    }
                    p {
                        color: #666;
                    }
                }
            }
            .delete-img {
                background: rgba(189, 195, 199,0.8);
                top: 0;
                right: 8px;
                width: 20px;
                height: 20px;
                line-height: 20px;
                text-align: center;
                border-radius: 0 4px 0 0;
                i {
                    font-size: 20px;
                    color: #fff;
                }
            }
            .checked-img {
                bottom: 0;
                width: calc(100% - 16px);
                background: rgba(40, 167, 69, 0.8);
                border-radius: 0 0 4px 4px;
                .btn-check {
                    color: #fff;
                }
            }
        }
        .info-post-mobile {

        }
    }
</style>
